import { render, staticRenderFns } from "./n-agree-modal.vue?vue&type=template&id=06ee2c50&"
import script from "./n-agree-modal.vue?vue&type=script&lang=ts&"
export * from "./n-agree-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports